import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css';
const Postmindfulness1 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "Introduction to Mindfulness",
      date: "May 1, 2023",
      image: "/assets/FeedItems/Xd9ntRxM19SBc3w0VF3z.svg",
      summary: "Understand the practice of mindfulness and its benefits. Learn about what mindfulness is, its benefits, and how to practice it in daily life.",
      path: "blog/mindfulness/post/postmindfulness1"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "Introduction to Mindfulness",
    date: "May 1, 2023",
    image: "/assets/FeedItems/Xd9ntRxM19SBc3w0VF3z.svg",
    summary: "Understand the practice of mindfulness and its benefits. Learn about what mindfulness is, its benefits, and how to practice it in daily life.",
    path: "blog/mindfulness/post/postmindfulness1"
  };
  return (
    <div class="body-gold">
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div>
        <p>
          Mindfulness is the practice of being present and fully engaged in the current moment. It involves paying attention to your thoughts, feelings, and sensations without judgment. Mindfulness can help reduce stress, improve focus, and enhance overall well-being.
        </p>
        <h2>What is Mindfulness?</h2>
        <p>
          Mindfulness is a mental state achieved by focusing one's awareness on the present moment while calmly acknowledging and accepting one's feelings, thoughts, and bodily sensations. It is often practiced through meditation, but it can also be incorporated into daily activities.
        </p>
        <h2>Benefits of Mindfulness</h2>
        <p>
          Practicing mindfulness has numerous benefits, including reduced stress and anxiety, improved concentration, better emotional regulation, and enhanced self-awareness. It can also promote physical health by lowering blood pressure and improving sleep quality.
        </p>
        <h2>How to Practice Mindfulness</h2>
        <p>
          There are many ways to practice mindfulness, including mindful breathing, body scan meditation, and mindful walking. The key is to find a practice that works for you and to incorporate it into your daily routine.
        </p>
        <p>
          Mindfulness is a powerful tool for enhancing mental and physical well-being. By cultivating a mindful approach to life, you can develop greater resilience, clarity, and inner peace.
        </p>
      </div>
    </div>
  );
};

export default Postmindfulness1;